import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sdk } from '../lib/sdk';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await sdk.auth.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main style={page}>
      <h1>Forgot password</h1>
      {sent ? (
        <p>If an account exists for that email, a reset link is on its way.</p>
      ) : (
        <form onSubmit={onSubmit} style={form_}>
          <label style={label}>
            {t('auth.email')}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={input}
            />
          </label>
          <button type="submit" disabled={busy} style={btn}>
            {busy ? t('common.loading') : 'Send reset link'}
          </button>
          {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
          <p>
            <Link to="/login">{t('auth.signIn')}</Link>
          </p>
        </form>
      )}
    </main>
  );
}

const page: React.CSSProperties = { maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif', padding: '0 1rem' };
const form_: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '1rem' };
const label: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '0.25rem' };
const input: React.CSSProperties = { padding: '0.5rem', border: '1px solid #ccc', borderRadius: 4, font: 'inherit' };
const btn: React.CSSProperties = { padding: '0.5rem 1rem', cursor: 'pointer' };
